import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { COMMUNITY_INVITE, COMMUNITY_NAME } from "../data/links";

const API_BASE = process.env.REACT_APP_API_BASE;

function Board({ title, entries, valueKey, formatValue, valueTitle }) {
  return (
    <section className="global-board">
      <h2>{title}</h2>
      {!entries?.length ? (
        <p className="profile-empty">No climbers yet.</p>
      ) : (
        <ol className="global-board-list">
          {entries.map((entry) => (
            <li key={`${title}-${entry.userId}`}>
              <span className="rank">#{entry.rank}</span>
              <Link to={`/u/${entry.userId}`} className="global-board-user">
                {entry.avatarUrl ? (
                  <img src={entry.avatarUrl} alt="" />
                ) : (
                  <span className="avatar-fallback" aria-hidden="true" />
                )}
                <span className="name" title={entry.username}>
                  {entry.username}
                </span>
              </Link>
              <span
                className="value"
                title={valueTitle ? valueTitle(entry) : undefined}
              >
                {formatValue
                  ? formatValue(entry)
                  : (entry[valueKey] || 0).toLocaleString()}
              </span>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}

export default function GlobalPage({ embedded = false }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await axios.get(`${API_BASE}/nocturne`);
        if (!cancelled) setData(res.data);
      } catch (err) {
        if (!cancelled) {
          setError(err.response?.data?.error || "Could not load global standings.");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <div className={embedded ? "portal-embed" : "global-page"}>
        <div className="page-loading">
          <div className="sync-spinner" />
        </div>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className={embedded ? "portal-embed" : "global-page"}>
        <div className="profile-login-gate">
          {!embedded && <h1>Global</h1>}
          <p>{error || "Nothing here yet."}</p>
          {!embedded && <Link to="/">Back home</Link>}
        </div>
      </div>
    );
  }

  const guild = data.guild || {};
  const boards = data.leaderboards || {};

  return (
    <div className={embedded ? "portal-embed" : "global-page"}>
      <header className="global-hero">
        {guild.icon && (
          <img src={guild.icon} alt="" className="global-guild-icon" />
        )}
        <div>
          {!embedded && <p className="global-kicker">Community hub</p>}
          <h1>{guild.name || COMMUNITY_NAME}</h1>
          <p className="global-lede">
            Global level, essence, and companion standings shared across every
            server Kami protects.
          </p>
          <div className="global-hero-actions">
            <a
              className="nav-login-btn"
              href={COMMUNITY_INVITE}
              target="_blank"
              rel="noreferrer"
            >
              Join {COMMUNITY_NAME}
            </a>
            {guild.memberCount != null && (
              <span className="global-stat">
                {Number(guild.memberCount).toLocaleString()} members
              </span>
            )}
          </div>
        </div>
      </header>

      <div className="global-boards">
        <Board
          title="Level"
          entries={boards.level}
          formatValue={(e) => `Lvl ${e.level}`}
        />
        <Board
          title="Essence"
          entries={boards.essence}
          valueKey="essence"
        />
        <Board
          title="Companions"
          entries={boards.pets}
          formatValue={(e) => `Lvl ${e.petLevel || 0}`}
          valueTitle={(e) => e.petName || undefined}
        />
      </div>
    </div>
  );
}
